/*
 * iroiroglass ヘッダーの挙動
 *
 * - ハンバーガーメニューの開閉（スマホのみ表示）
 * - ロゴ・ブランド名をクリックしたとき、トップページなら先頭へスクロール
 * - 右の帯のボタンを、いま見ているセクションに合わせて大きくする
 */
(function () {
  'use strict';

  /* ── ハンバーガー ── */

  function initMenu(header) {
    var openBtn = header.querySelector('.iroiro-header__openbtn');
    var nav = header.querySelector('.iroiro-header__nav');
    if (!openBtn || !nav) return;

    function setOpen(isOpen) {
      header.classList.toggle('is-active', isOpen);
      openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    setOpen(false);

    openBtn.addEventListener('click', function () {
      setOpen(!header.classList.contains('is-active'));
    });

    /*
     * 開いているあいだは、パネルのどこを触っても閉じる。
     * リンクなら閉じたうえでそのまま遷移する（同一ページ内リンク対策）。
     * 閉じ方は ×（ハンバーガー）／背景／Escape の3通り。
     *
     * PCではメニューは上部バーの中に並んでいるだけで is-active にならないため、
     * ここは素通りする。
     */
    nav.addEventListener('click', function () {
      if (header.classList.contains('is-active')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-active')) {
        setOpen(false);
        openBtn.focus();
      }
    });
  }

  /* ── ロゴからトップへ ── */

  function initToTop(header) {
    var links = header.querySelectorAll('.iroiro-header__logo a, .iroiro-header__brand a');
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function (event) {
        // トップページ以外では通常のリンクとして動かす
        if (window.location.pathname !== '/') return;
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  /* ── 現在地に合わせてボタンを大きくする ── */

  /*
   * 画面の少し上寄りに引いた1本の線が、どのセクションの中にあるかで判定する。
   *
   * 【線の位置】画面の高さの45%。ただしバーの下300pxを超えないところで止める。
   *
   * 単純に画面の中央にすると、背の低いセクション（store など）は
   * ボタンを押して飛んだ直後に中央まで届かず、一つ前のボタンが
   * 大きいままになってしまう。飛んだ先はバーの真下から始まるため、
   * 「セクションの高さ ＞ 線の位置 − バーの高さ」でないと自分が選ばれない。
   * 画面が縦に長いほど中央は遠くなるので、上限を設けて外れないようにしている。
   *
   * 逆に線をバーのすぐ下に置くと、セクションの上端が触れた瞬間に
   * 切り替わるため、見た目にはまだ前のセクションを見ているのに
   * ボタンだけ先に進んでしまう。その中間を取っている。
   *
   * 判定に使うのは各セクションの現在位置だけで、高さや順番を
   * 実測pxで持たないため、画面幅が変わっても並べ替えても成立する。
   *
   * トップページ以外では data-iroiro-anchors を出していないので、
   * ここは何もしない。飛び先が同じページの中に無く、スクロール位置から
   * 現在地を決められないため。あちらの現在地はテンプレートを見て
   * Liquid 側が付けている（sections/iroiro-header.liquid）。
   */
  function initSpy(header) {
    var rail = header.querySelector('[data-iroiro-anchors]');
    if (!rail) return;

    var links = Array.prototype.slice.call(rail.querySelectorAll('.iroiro-header__anchor'));
    var pairs = [];

    links.forEach(function (link) {
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.querySelector(id);
      if (target) pairs.push({ link: link, target: target });
    });

    if (!pairs.length) return;

    function headerHeight() {
      return (
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--iroiro-header-height'),
          10
        ) || 80
      );
    }

    function update() {
      var line = Math.min(window.innerHeight * 0.45, headerHeight() + 300);
      var current = null;

      /*
       * 上から順に見て、その線より上で始まっているものを拾い続ける。
       * 最後に残るのが「いま線の位置にあるセクション」。
       *
       * どれにも入っていないとき（ボタンを持たない gallery の中など）は
       * 直前に通過したものが残る。これは pairs が文書順に並んでいるため。
       */
      pairs.forEach(function (pair) {
        if (pair.target.getBoundingClientRect().top <= line) current = pair.link;
      });

      links.forEach(function (link) {
        link.classList.toggle('is-current', link === current);
        if (link === current) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    // スクロール中は描画に合わせて間引き、1フレームに1回だけ測る
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        update();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // 画像の読み込みで位置が変わるため、読み込み完了後にも取り直す
    window.addEventListener('load', onScroll);
    update();
  }


  /* ── 飛び先を「中身が出る位置」に合わせる ── */

  /*
   * 帯のボタンは #store のようにセクションの先頭へ飛ぶ。
   * ふつうはそれでよいが、セクションの先頭と見せたいものが
   * 離れている場合がある。store は縦積みのとき写真列が先に来るため、
   * 先頭へ飛ぶと写真の手前に着地し、文章はまだ画面の外にある。
   *
   * セクションの中に data-iroiro-anchor-focus を持つ要素があれば、
   * その要素が画面の指定した高さ（%）に来る位置へ飛ぶ。
   * 写真の枚数で距離が変わるため、CSS の scroll-margin-top では表せない。
   *
   * 現在地の判定（initSpy）はセクションの先頭を見ているので、
   * そちらには触れていない。id を動かすと判定が壊れる。
   *
   * 指定が無いセクションは何もせず、通常のアンカーとして動く。
   */
  function initAnchorFocus(header) {
    var rail = header.querySelector('[data-iroiro-anchors]');
    if (!rail) return;

    rail.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.iroiro-header__anchor');
      if (!link) return;

      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;

      var section = document.querySelector(id);
      if (!section) return;

      var focus = section.querySelector('[data-iroiro-anchor-focus]');
      if (!focus) return;

      /*
       * 着地の高さもレイアウトで変わる。狭い幅の指定があればそちらを使う
       * （出現位置の指定と対になっている）。
       */
      var wide = window.matchMedia('(min-width: 1024px)').matches;
      var raw = wide ? focus.dataset.iroiroAnchorFocus : focus.dataset.iroiroAnchorFocusNarrow;
      if (raw === undefined || raw === '') raw = focus.dataset.iroiroAnchorFocus;
      var ratio = parseFloat(raw);
      if (isNaN(ratio)) return;

      event.preventDefault();

      /*
       * 出現アニメーションを先に始めておく。
       *
       * 着地点は「本来そこで出はじめる位置」なので、そのまま飛ぶと
       * 到着した瞬間からアニメーション（1.2秒）が始まり、着いた時点では
       * まだ文字が見えない。スクロールしているあいだに出し切るため、
       * 飛ぶ前に表示状態にしておく。
       */
      focus.classList.add('is-visible');
      focus
        .querySelectorAll('.iroiro-anim-fade, .iroiro-anim-fade-up, .iroiro-anim-flowing, .iroiro-anim-rise')
        .forEach(function (el) {
          el.classList.add('is-visible');
        });

      var top =
        focus.getBoundingClientRect().top +
        window.pageYOffset -
        window.innerHeight * (ratio / 100);
      if (top < 0) top = 0;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function initHeader(header) {
    if (!header || header.dataset.iroiroHeaderReady === 'true') return;
    header.dataset.iroiroHeaderReady = 'true';

    initMenu(header);
    initToTop(header);
    initSpy(header);
    initAnchorFocus(header);
  }

  function initAll() {
    document.querySelectorAll('.iroiro-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // テーマエディタでセクションを編集したときの再初期化
  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('.iroiro-header');
    if (header) initHeader(header);
  });
})();
